import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DxDataGrid, {
    DxColumn,
    DxFilterRow,
    DxStateStoring,
    DxPaging,
    DxHeaderFilter, DxPager,
    DxButton
} from "devextreme-vue/data-grid";
import { UserItem, UserRole } from "@/services/entities/UserItem";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserManagementTable',
  props: {
    data: { Type: [] as UserItem[], default: [] as UserItem[] }
},
  emits: ["detail"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const selectedKeys = ref([] as number[]);

const props = __props;

function showDetail(e: any) {
    selectedKeys.value = [e.row.data.id];
    emit("detail", e.row.data.id);
}

function clearDetail(e: any) {
    emit("detail", null);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxDataGrid), {
    "hover-state-enabled": true,
    "show-borders": false,
    "data-source": props.data,
    "key-expr": "id",
    id: "user-management-table",
    "selected-row-keys": selectedKeys.value,
    "auto-navigate-to-focused-row": true
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DxFilterRow), { visible: true }),
      _createVNode(_unref(DxHeaderFilter), { visible: true }),
      _createVNode(_unref(DxStateStoring), {
        enabled: true,
        type: "localStorage",
        "storage-key": "user-management-table"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "id",
        "data-type": "string",
        caption: "Id",
        visible: false
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "fullName",
        "data-type": "string",
        caption: "Name"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "userRole",
        "data-type": "string",
        caption: "Role"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "teamLeader.email",
        "data-type": "string",
        caption: "Team leader"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "currentRate.rate.name",
        "data-type": "string",
        caption: "Current rate"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "isDeleted",
        "data-type": "boolean",
        caption: "Deleted",
        "allow-header-filtering": false,
        "allow-filtering": true
      }),
      _createVNode(_unref(DxColumn), {
        type: "buttons",
        caption: "Actions",
        width: 70
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            hint: "View detail",
            icon: "eyeopen",
            "styling-mode": "contained",
            type: "normal",
            onClick: showDetail
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxPaging), { "page-size": 10 }),
      _createVNode(_unref(DxPager), {
        "show-page-size-selector": true,
        "allowed-page-sizes": [5, 10, 20]
      })
    ]),
    _: 1
  }, 8, ["data-source", "selected-row-keys"]))
}
}

})